import { faEye, faEyeSlash, faSpinner } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { toast } from "react-hot-toast";
import useAxios from "../../../../MainComponents/Hooks/useAxios";

const AdminChangePassword = () => {
  const [hide, setHide] = useState(false);
  const [formValues, setFormValues] = useState({});
  const [formFlag, setFormFlag] = useState();
  const [formDependency, setFormDependency] = useState(false);

  const {
    register,
    handleSubmit,
    getValues,
    formState: { errors, isValid },
    reset,
  } = useForm({ mode: "onTouched" });

  const [
    EditAdminPasswordSuccess,
    EditAdminPasswordErrors,
    EditAdminPasswordLoading,
  ] = useAxios(
    process.env.REACT_APP_ADMIN_CHANGE_PROFILE_PASSWORD_API,
    "POST",
    formFlag,
    formDependency,
    formValues,
  );

  const onSubmit = (formData) => {
    setFormValues(formData);
    setFormFlag("EditAssistantPassword");
    setFormDependency(true);
  };

  useEffect(() => {
    if (EditAdminPasswordSuccess) {
      toast.success("Update Password Successfully..");
      setFormFlag("");
      setFormDependency(false);
      reset();
    }
  }, [EditAdminPasswordSuccess, reset]);

  useEffect(() => {
    if (EditAdminPasswordErrors) {
      toast.error(EditAdminPasswordErrors.message);
      setFormFlag("");
      setFormDependency(false);
    }
  }, [EditAdminPasswordErrors]);

  return (
    <form onSubmit={handleSubmit(onSubmit)} className="admin-profile__card">
      <div className="admin-profile__card-head">
        <h4 className="admin-profile__card-title">Password</h4>
        <p className="admin-profile__card-sub">
          Use a strong password with at least 6 characters
        </p>
      </div>

      <div className="admin-profile__fields">
        <div className="admin-profile__field">
          <label htmlFor="password">Password</label>
          <div className="admin-profile__input-wrap">
            <input
              id="password"
              className="admin-profile__input"
              type={hide ? "text" : "password"}
              placeholder="Enter new password"
              autoComplete="new-password"
              {...register("password", {
                required: true,
                maxLength: 25,
                minLength: 6,
              })}
            />
            <FontAwesomeIcon
              onClick={() => setHide(!hide)}
              className="admin-profile__eye"
              icon={hide ? faEye : faEyeSlash}
            />
          </div>
          {errors.password && (
            <p className="admin-profile__error">
              {errors.password.type === "required" && "This field is required."}
              {errors.password.type === "maxLength" &&
                "Password Max length is 25 char."}
              {errors.password.type === "minLength" &&
                "Password Min length is 6 char."}
            </p>
          )}
        </div>

        <div className="admin-profile__field">
          <label htmlFor="password_confirmation">Confirm Password</label>
          <div className="admin-profile__input-wrap">
            <input
              id="password_confirmation"
              className="admin-profile__input"
              type={hide ? "text" : "password"}
              placeholder="Confirm new password"
              autoComplete="new-password"
              {...register("password_confirmation", {
                required: true,
                maxLength: 25,
                minLength: 6,
                validate: (value) => value === getValues("password"),
              })}
            />
            <FontAwesomeIcon
              onClick={() => setHide(!hide)}
              className="admin-profile__eye"
              icon={hide ? faEye : faEyeSlash}
            />
          </div>
          {errors.password_confirmation && (
            <p className="admin-profile__error">
              {errors.password_confirmation.type === "required" &&
                "This field is required."}
              {errors.password_confirmation.type === "maxLength" &&
                "Confirm password Max length is 25 char."}
              {errors.password_confirmation.type === "minLength" &&
                "Password Min length is 6 char."}
              {errors.password_confirmation.type === "validate" &&
                "Passwords don't match."}
            </p>
          )}
        </div>
      </div>

      <button
        type="submit"
        disabled={!isValid || EditAdminPasswordLoading}
        className="admin-profile__btn"
      >
        {EditAdminPasswordLoading ? (
          <FontAwesomeIcon icon={faSpinner} spin />
        ) : (
          "Update Password"
        )}
      </button>
    </form>
  );
};

export default AdminChangePassword;
